
import { Component, Vue, Watch } from 'vue-property-decorator'
import { apiResetPassword } from '@/api/setting'
import { apiLogout } from '@/api/app'


@Component
export default class ListsDetail extends Vue {
  /** S Data **/

  // 添加商城表单數據
  form: any = {
    origin_password: '', // 原密碼
    password_confirm: '', // 新密碼
    password: '' // 確認密碼
  };

  // 表单校验
  rules = {
    origin_password: [{ required: true, message: '請輸入原密碼', trigger: 'blur' }],
    password_confirm: [
      { required: true, message: '請輸入密碼', trigger: 'blur' },
      {
        validator: (rule: object, value: string, callback: any) => {
          !value
            ? callback(new Error('請輸入密碼'))
            : callback()
        },
        trigger: 'blur'
      }
    ],
    password: [
      { required: true, message: '請再次输入密碼', trigger: 'blur' },
      {
        validator: (rule: object, value: string, callback: any) => {
          if (this.form.password_confirm) {
            if (!value) callback(new Error('請再次输入密碼'))
            if (value !== this.form.password_confirm) callback(new Error('两次输入密碼不一致!'))
          }
          callback()
        },
        trigger: 'blur'
      }
    ]
  };

  /** E Data **/

  /** S Methods **/
  // 點擊表单提交
  onSubmit (formName: string) {
    // 验证表单格式是否正確
    const refs = this.$refs[formName] as HTMLFormElement
    refs.validate((valid: boolean): any => {
      if (!valid) return
      this.handleEdit()
    })
  }

  async handleEdit () {
    await apiResetPassword({ ...this.form })
    this.logout()
  }

  logout () {
    apiLogout().then(() => {
      this.$store.commit('setUserInfo', {})
      this.$store.commit('setPermission', {})
      this.$router.push('/account/login')
    })
  }
  /** E Methods **/
}
